module.exports = __webpack_public_path__ + "img/UXUI.54b1e59d.svg";